import { line, curveNatural } from 'd3'

export function selectElement(d, name) {
  for (var i = 0; i < d.length; i++) {
    if (d[i].name.toLowerCase() === name) {
      return d[i]
    }
  }
}

export function updDim() {
  let w = window.innerWidth
  let size = w < 1100 ? 'mobile' : 'desktop'
  w = w < 240 ? 240 : w < 1100 ? w : w - 180
  let h = window.innerHeight
  let i = Math.min(w / 2.5, h / 2)
  const data = {
    size: {
      width: w,
      height: h,
      device: size,
    },
    zoomInit: i,
    move: false,
  }
  return data
}

export function urlUpdState(layer, type, elementData, n, state) {
  const data = {
    ...state,
    selected: {
      ...state.selected,
      layer: layer === '' ? state.selected.layer : layer,
      now: n,
      type: type,
      data: elementData,
      name: elementData.name,
    },
    dPos: [elementData.lon, elementData.lat],
    dLevel: type === 'pop' ? 4 : elementData.zoom,
  }
  return data
}

export function bezier(p) {
  return line()
    .curve(curveNatural)
    .x(d => {
      return p()(d)[0]
    })
    .y(d => {
      return p()(d)[1]
    })
}

export function simpleLine(p) {
  return line()
    .x(d => {
      return p()(d)[0]
    })
    .y(d => {
      return p()(d)[1]
    })
}

// Función para evitar comportamiento normal (click & hover) de cables
export function cableCanBeSelected(cableName) {
  return (cableName.toUpperCase() !== 'ATLANTIS-II' &&
          cableName.toUpperCase() !== 'SAT-3' &&
          cableName.toUpperCase() !== 'COLUMBUS-III');
}
